import script from "./DashboardIcons.vue?vue&type=script&lang=js"
export * from "./DashboardIcons.vue?vue&type=script&lang=js"

import "./DashboardIcons.vue?vue&type=style&index=0&id=10417d02&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-10417d02"]])

export default __exports__